import { useState } from "react";
import { Link } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { Button } from "@/components/ui/button";
import { Particles } from "@/components/Particles";
import { AppSidebar } from "@/components/AppSidebar";
import { LegalDisclaimer } from "@/components/LegalDisclaimer";
import { Footer } from "@/components/Footer";
import { Sparkles } from "lucide-react";
import ImageCard from "@/components/gallery/ImageCard";
import VideoCard from "@/components/gallery/VideoCard";

// Before/After image pairs
const imageCards = [
  {
    before: "linear-gradient(135deg, #8e9eab, #eef2f3)",
    after: "linear-gradient(135deg, #667eea, #764ba2)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/Sem%20t%C3%ADtulo2.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/Sem%20t%C3%ADtulo.webp",
  },
  {
    before: "linear-gradient(135deg, #bdc3c7, #2c3e50)",
    after: "linear-gradient(135deg, #f093fb, #f5576c)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/fERQ0eU3dH9DOe-8Efnc7_output_1.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/5f19ewd6jb.ucarecd.webp",
  },
  {
    before: "",
    after: "",
    beforeImage: "https://assets.loverslabs.art/Galeria01/LoversLabs-Edit-MLY3B35HVPLSR2Q0.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/aKoBG3e_ZQtu7qSwAD64B_output_1.webp",
  },
  {
    before: "linear-gradient(135deg, #c9d6ff, #e2e2e2)",
    after: "linear-gradient(135deg, #43e97b, #38f9d7)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/5DlJs96WCu908UUm-txzK_output_1.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/kKcxjAau74w2So3w2Nozn_output_1.webp",
  },
  {
    before: "linear-gradient(135deg, #e0c3fc, #8ec5fc)",
    after: "linear-gradient(135deg, #fa709a, #fee140)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883162196-gtutmj.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883133497-pro6bl.webp",
  },
  {
    before: "linear-gradient(135deg, #a8c0ff, #3f2b96)",
    after: "linear-gradient(135deg, #f6d365, #fda085)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883202468-4ly4cm.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883303773-zfubi.webp",
  },
  {
    before: "linear-gradient(135deg, #cfd9df, #e2ebf0)",
    after: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883343103-sqg8mr.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883370195-8mavg.webp",
  },
  {
    before: "linear-gradient(135deg, #89f7fe, #66a6ff)",
    after: "linear-gradient(135deg, #fddb92, #d1fdff)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883409118-rgf16.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883437948-lc623a.webp",
  },
  {
    before: "linear-gradient(135deg, #c1dfc4, #deecdd)",
    after: "linear-gradient(135deg, #ff9a9e, #fecfef)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771908346707-3sg4s4.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883504005-jq7fs0c.webp",
  },
  {
    before: "linear-gradient(135deg, #accbee, #e7f0fd)",
    after: "linear-gradient(135deg, #f77062, #fe5196)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883536476-av1nsg.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883561117-5ympt7.webp",
  },
  {
    before: "linear-gradient(135deg, #e8cbc0, #636fa4)",
    after: "linear-gradient(135deg, #84fab0, #8fd3f4)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883602236-d7vv9k.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771908489949-xgk51.webp",
  },
  {
    before: "linear-gradient(135deg, #d5d4d0, #eeeeec)",
    after: "linear-gradient(135deg, #a1c4fd, #c2e9fb)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771908562118-rt7fg.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883716852-hhdpo7.webp",
  },
  {
    before: "linear-gradient(135deg, #b8cbb8, #b8cbb8)",
    after: "linear-gradient(135deg, #ffecd2, #fcb69f)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883749724-m449rq.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883791494-6mpak.webp",
  },
  {
    before: "linear-gradient(135deg, #dfe6e9, #b2bec3)",
    after: "linear-gradient(135deg, #d4fc79, #96e6a1)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771908649106-um3s8n.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883854551-zf413g.webp",
  },
  {
    before: "linear-gradient(135deg, #c4c5c7, #dcdddf)",
    after: "linear-gradient(135deg, #f794a4, #fdd6bd)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771883903800-wb0m0k.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883924779-ha09e.webp",
  },
  {
    before: "linear-gradient(135deg, #e6dada, #274046)",
    after: "linear-gradient(135deg, #89f7fe, #66a6ff)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771908705344-cerxsq.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771883984660-hhk39c.webp",
  },
  {
    before: "linear-gradient(135deg, #d9a7c7, #fffcdc)",
    after: "linear-gradient(135deg, #667eea, #764ba2)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771908797504-9u0xkf.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771884059193-8qpxgm.webp",
  },
  {
    before: "linear-gradient(135deg, #c1c8e4, #dee4fd)",
    after: "linear-gradient(135deg, #ff758c, #ff7eb3)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771884103490-olflb3.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771884143043-9j4tx.webp",
  },
  {
    before: "linear-gradient(135deg, #a6c0fe, #f68084)",
    after: "linear-gradient(135deg, #30cfd0, #330867)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771884202589-x7ghfh.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771884236801-0e551k.webp",
  },
  {
    before: "linear-gradient(135deg, #e2d1c3, #fdfcfb)",
    after: "linear-gradient(135deg, #fbc2eb, #a6c1ee)",
    beforeImage: "https://assets.loverslabs.art/Galeria01/converted-1771884267056-wspznf.webp",
    afterImage: "https://assets.loverslabs.art/Galeria01/converted-1771884300147-vgkxaj.webp",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771982790072-elgyrh.webp",
    videoSrc: "https://assets.loverslabs.art/Exemple/5nPgPi_cRwZ_PFJpr1ySi_I8Hq2Vp6.mp4",
  },
];

// Video gallery data
const videoCards = [
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771968414188-3ggbxl.webp",
    videoSrc: "https://assets.loverslabs.art/Exemple/Video%20Project.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771969552672-k9dwkw.webp",
    videoSrc: "https://assets.loverslabs.art/Exemple/-4dNZ8PXKCoTf76LBKhFt_N1tIqBf4.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771969706743-ba49ci.webp",
    videoSrc: "https://assets.loverslabs.art/Galeria01/OekyvCIssRdN-Vz_zfnwz_4ugM4svB.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771970225275-e766v2.webp",
    videoSrc: "https://assets.loverslabs.art/Galeria01/adPbtLNHgDwx5iEg4l5PHC_og0bERF1.mp4.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771970928623-nh8rmg.webp",
    videoSrc: "https://v3b.fal.media/files/b/0a8fd042/JCVVPnRpsdi9XSM1B5Wci_vsSk4tin.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/Nova%20pasta%20(2)/converted-1771972642865-0lvd3.webp",
    videoSrc: "https://assets.loverslabs.art/Galeria01/1Nz_VTA9X0pRUJQQAzcxy_iDX73H77.mp4",
  },
  {
    coverImage: "https://assets.loverslabs.art/Exemple/converted-1771982790072-elgyrh.webp",
    videoSrc: "https://assets.loverslabs.art/Galeria01/Hm72KFuhbTY1TjJsM4CaJ_Si9J9C4y.mp4",
  },
];

const Gallery = () => {
  const [activeVideoIndex, setActiveVideoIndex] = useState<number | null>(null);
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navigation />
      <Particles />

      <AppSidebar>
        <main className="flex-1 overflow-x-hidden">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
              {/* Image Gallery Section */}
              <section className="py-16">
                <h1 className="text-4xl md:text-5xl font-bold text-center text-foreground mb-3">
                  Image AI: See the Magic Unfold!
                </h1>
                <p className="text-center text-muted-foreground text-lg mb-12">
                  Drag the slider to switch between before and after.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 min-w-0 w-full">
                  {imageCards.map((c, i) => (
                    <ImageCard
                      key={i}
                      beforeGradient={c.before}
                      afterGradient={c.after}
                      beforeImage={c.beforeImage}
                      afterImage={c.afterImage}
                    />
                  ))}
                </div>
              </section>

              {/* Video Gallery Section */}
              <section className="py-16">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-3">
                  Video AI: Bring Photos to Life!
                </h2>
                <p className="text-center text-muted-foreground text-lg mb-12">Click any image to see it move.</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 min-w-0 w-full">
                  {videoCards.map((v, i) => (
                    <VideoCard
                      key={i}
                      coverImage={v.coverImage}
                      videoSrc={v.videoSrc}
                      shouldPause={activeVideoIndex !== null && activeVideoIndex !== i}
                      onPlay={() => setActiveVideoIndex(i)}
                    />
                  ))}
                </div>
              </section>

              {/* CTA */}
              <section className="py-16 text-center">
                <Link to="/generator">
                  <Button
                    size="lg"
                    className="bg-gold hover:bg-gold/90 text-black font-bold text-lg px-8 py-6 rounded-full"
                  >
                    <Sparkles className="w-5 h-5 mr-2" />
                    Start Creating
                  </Button>
                </Link>
              </section>

              <LegalDisclaimer />
            </div>
          </div>
          <Footer />
        </main>
      </AppSidebar>
    </div>
  );
};

export default Gallery;
